import { render, staticRenderFns } from "./OtpForm.vue?vue&type=template&id=aaa8181c&scoped=true"
import script from "./OtpForm.vue?vue&type=script&lang=js"
export * from "./OtpForm.vue?vue&type=script&lang=js"
import style0 from "./OtpForm.vue?vue&type=style&index=0&id=aaa8181c&prod&lang=css"
import style1 from "./OtpForm.vue?vue&type=style&index=1&id=aaa8181c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa8181c",
  null
  
)

export default component.exports